/**
 * @generated SignedSource<<14d5fc28313fb22a9ab8f8acb3ec440f>>
 * @relayHash fceff7534db1aba5cc567c867318917b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7cdc9cca958b9273f1d1701081f2b2a0f7e89750e63a5a73fc2a9f516a0785e4

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectGroupPermissionsSettingsAggQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type ProjectGroupPermissionsSettingsAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupPermissionsSettings">;
};
export type ProjectGroupPermissionsSettingsAggQuery = {
  response: ProjectGroupPermissionsSettingsAggQuery$data;
  variables: ProjectGroupPermissionsSettingsAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectGroupPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v1/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectGroupPermissionsSettings"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectGroupPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "TownsquareProjectsAppPermissionPolicyConnection",
            "kind": "LinkedField",
            "name": "projects_appPermissionPolicies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectsAppPermissionPolicyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectsAppPermissionPolicy",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "concreteType": "IdentityGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isDefaultGroup"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "userCount"
                      },
                      {
                        "concreteType": "TownsquareProductRole",
                        "kind": "LinkedField",
                        "name": "productRoles",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "role"
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareProjectsAppPermissionEntry",
                        "kind": "LinkedField",
                        "name": "appPermissions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "permission"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPermitted"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "fceff7534db1aba5cc567c867318917b",
    "id": "7cdc9cca958b9273f1d1701081f2b2a0f7e89750e63a5a73fc2a9f516a0785e4",
    "metadata": {},
    "name": "ProjectGroupPermissionsSettingsAggQuery",
    "operationKind": "query",
    "text": "query ProjectGroupPermissionsSettingsAggQuery(\n  $containerId: ID!\n  $isM3GroupPermsEnabled: Boolean!\n) {\n  ...ProjectGroupPermissionsSettings_1GKbF9 @include(if: $isM3GroupPermsEnabled)\n}\n\nfragment ProjectGroupPermissionsSettings_1GKbF9 on Query {\n  projects_appPermissionPolicies(containerId: $containerId, first: 100) @optIn(to: \"Townsquare\") {\n    edges {\n      node {\n        id\n        group {\n          name\n          id\n        }\n        isDefaultGroup\n        isEditable\n        userCount\n        productRoles {\n          role\n        }\n        appPermissions {\n          permission\n          isPermitted\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9ad342251ac7fde7f812879d1344b3ea";

export default node;
